/*
 * @Author: Gang Jiang 
 * @Date: 2025-02-28 10:02:55 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2025-02-28 13:49:14
 */
<template>
  <div class="help-page">
    <breadcrumbs url="about-artemis-ads" lastTitle="Publisher FAQ"/>
    <div class="docs">
      <h1>Promotions and Global Reach</h1>
      <h2>Can I promote Artemis Ads products outside of the US?</h2>
      <p>Yes.</p>
      <p>
        You can promote Artemis Ads products from anywhere in the world,
        regardless of your location.
      </p>
      <p>
        ArtemisAds.com also has separate sites for the following countries:
        United States, Canada, United Kingdom, Germany and France. You may
        enroll in all or part of them.
      </p>
      <h2>What are Promotion Requests, and how do they work?</h2>
      <p>
        Promotion Requests allow affiliates to request a specific promotional
        code or deal from a brand to enhance their marketing efforts.
      </p>
      <ul>
        <li>
          If an affiliate believes a promo code or special deal would help
          increase conversions, they can submit a Promotion Request.
        </li>
        <li>The brand decides whether to approve the request.</li>
        <li>
          If approved, the affiliate will receive a unique promo code or deal to
          share with their audience, helping drive sales and earn commissions.
        </li>
      </ul>
      <h2>Is there a limit to how many Artemis Ads products I can promote?</h2>
      <p>No.</p>
      <p>
        There is no limit to the number of Artemis Ads products you can promote.
      </p>
      <p>
        However, for better performance, it’s recommended to choose products
        relevant to your niche and audience to maximize engagement and earnings.
      </p>
    </div>
  </div>
</template>
<script setup>
import Breadcrumbs from '../breadcrumbs.vue'
</script>